export default "__VITE_ASSET__CFbXJYNw__"